import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-headers-generic',
  templateUrl: './table-headers-generic.component.html',
  styleUrls: ['./table-headers-generic.component.css']
})
export class TableHeadersGenericComponent implements OnInit {

  @Input() col: any;
  constructor() { }

  ngOnInit(): void {
  }

}
